export default "__VITE_ASSET__B9Vqq6BB__"